const SELECTOR = 'a[target="_blank"]';
const WARNING_ID = "js-new-tab-a11y-warning";

function createWarningElement() {
	if (document.getElementById(WARNING_ID)) {
		return;
	}

	const element = document.createElement("span");
	element.id = WARNING_ID;
	element.hidden = true;
	element.textContent = "(opens in a new window)";
	document.body.appendChild(element);
}

export function initNewTabAccessibility() {
	const flagged = new WeakSet();

	const flagLink = (link) => {
		if (flagged.has(link)) {
			return;
		}

		const ids = (link.getAttribute("aria-describedby") || "")
			.split(/\s+/)
			.filter(Boolean);

		if (!ids.includes(WARNING_ID)) {
			ids.push(WARNING_ID);
		}

		link.setAttribute("aria-describedby", ids.join(" "));

		flagged.add(link);
	};

	const scan = (root) => {
		root.matches?.(SELECTOR) && flagLink(root);
		root.querySelectorAll?.(SELECTOR).forEach(flagLink);
	};

	createWarningElement();
	scan(document.body);

	new MutationObserver((mutations) => {
		mutations.forEach((mutation) =>
			mutation.addedNodes.forEach(
				(node) => node.nodeType === Node.ELEMENT_NODE && scan(node),
			),
		);
	}).observe(document.body, { childList: true, subtree: true });
}
